import React, { useEffect, useRef, useState } from "react";
import { partnerMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import PartnerPopup from "../popup-containers/PartnerPopup";
import MainPopup from "../popup-containers/MainPopup";
import toast, { Toaster } from "react-hot-toast";
import { BindAPI, IUDAPI, ImageAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";

const PartnerMaster = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [popupFlag, setPopupFlag] = useState(0);
  const [popupImage, setPopupImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const childRef = useRef();
  const [partnerFields, setPartnerFields] = useState({
    partnerId: "COMP",
    partnerName: "",
    address: "",
    country: "77",
    state: "",
    city: "",
    type: "C",
    pinCode: "",
    date: new Date(),
    firstName: null,
    LastName: "",
    showImage: "",
    designation: "",
    contactNumber: "",
    email: "",
  });

  const [partnerFieldsError, setPartnerFieldsError] = useState({
    partnerIdError: "",
    partnerNameError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    cityError: "",
    pinCodeError: "",
    dateError: "",
    firstNameError: "",
    LastNameError: "",
    designationError: "",
    contactNumberError: "",
    emailError: "",
    showImageError: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setPartnerFields({ ...partnerFields, date: formattedDate });
    };

    fetchData();
  }, []);
  const handlePartnerFieldsChange = (value, name) => {
    setPartnerFields({
      ...partnerFields,
      [name]: value,
    });
  };
  const [mstPartnerId, setMstPartnerId] = useState("");
  const [partnerData, setPartnerData] = useState({});
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [uploadDetails, setUploadDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [partnerdata2, setPartnerdata2] = useState({});

  // view details end

  const [bindPartnerMasterDatas, setBindPartnerMasterDatas] = useState([]);
  const [bindImageDatas, setBindImageDatas] = useState([]);
  const [bindContactNoAndEmailDatas, setBindContactNoAndEmailDatas] = useState(
    []
  );
  const [bindCommoditiesDD, setBindCommoditiesDD] = useState([]);

  const BindPartnerGridData = async () => {
    try {
      setIsLoading(true);
      const { data } = await BindAPI("PartnerAPI/BindPartner");

      setBindPartnerMasterDatas(data?.Table ?? []);
      if (data?.Table.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      } else {
        showAdd();
      }
      setBindContactNoAndEmailDatas(data?.Table1 ?? []);
      setBindImageDatas(data?.Table4 ?? []);
    } catch (error) {
      console.error("Error fetching partner data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    BindPartnerGridData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      binddrpCoutrydata();
      // binddrpstatedata();
      // bindDrpsDesignationData();
    };
    fetchData();
  }, []);

  const binddrpCoutrydata = async () => {
    try {
      const bindCountrydatadrp = await BindAPI("CountryAPI/BindCountry");
      if (bindCountrydatadrp.data.Table.length > 0) {
        const countryDD = bindCountrydatadrp.data.Table.map((m) => ({
          value: m.MstCountryId,
          label: m.CountryName_en,
        }));
        setCountryBindDD(countryDD);
      } else {
        setCountryBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  // const binddrpstatedata = async () => {
  //   try {
  //     const bindStatedatadrp = await BindAPI("StateAPI/BindState");
  //     if (bindStatedatadrp.data.Table.length > 0) {
  //       const stateDD = bindStatedatadrp.data.Table.map((m) => ({
  //         value: m.MstStateId,
  //         label: m.StateName_en,
  //       }));

  //       setStateBindDD(stateDD);
  //     } else {
  //       setStateBindDD([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching state data:", error);
  //   }
  // };

  // const bindDrpsDesignationData = async () => {
  //   try {
  //     const bindDesignationDataDrp = await BindAPI(
  //       "MasterDataAPI/BindMasterDatas"
  //     );
  //     if (bindDesignationDataDrp.data.Table2.length > 0) {
  //       const designationDD = bindDesignationDataDrp.data.Table2.map((m) => ({
  //         value: m.MstDesignationId,
  //         label: m.Designation,
  //       }));

  //       setDesignationBindDD(designationDD);
  //     } else {
  //       setDesignationBindDD([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching state data:", error);
  //   }
  // };

  // useEffect(() => {
  //   const getSelectedLocation = async () => {
  //     const locationResponse = await BindAPI("LocationAPI/GetLocation");
  //     setGetLocationDatas(locationResponse.data.Table);
  //   };
  //   getSelectedLocation();
  // }, []);

  // useEffect(() => {
  //   // Find the selected state in getLocationDatas
  //   const stateSelectedValue = getLocationDatas.find(
  //     (item) => item.MstStateId == partnerFields.state // Replace with the desired MstStateId
  //   );
  //   if (stateSelectedValue) {
  //     const branchProjectLabels = getLocationDatas
  //       .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
  //       .map((item) => ({
  //         MstLocationId: item.MstLocationId,
  //         LocationName_en: item.LocationName_en,
  //       }));
  //     const branchProjectSelected = branchProjectLabels.map((LC) => ({
  //       value: LC.MstLocationId, // Replace with the appropriate value
  //       label: LC.LocationName_en,
  //     }));
  //     setBranchProjectBindDD(branchProjectSelected);
  //   } else {
  //   }
  // }, [partnerFields.state]);

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setPartnerFields({ ...partnerFields, date: formattedDate });
    localStorage.setItem("screenMode", "add");
  };

  const cancel = () => {
    if (
      childRef.current &&
      typeof childRef.current.childCancelFunction === "function"
    ) {
      childRef.current.childCancelFunction(); // ✅ Safe call
    } else {
      console.error("childCancelFunction is not defined");
    }
    setIsLoading(false);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    clear();
    localStorage.setItem("screenMode", "");
  };
  const clear = () => {
    //Clear Company data
    BindPartnerGridData();
    setPartnerFields({
      partnerId: "COMP",
      partnerName: "",
      address: "",
      country: "1",
      state: "",
      city: "",
      type: "C",
      pinCode: "",
      date: new Date(),
      firstName: null,
      LastName: "",
      showImage: "",
      designation: "",
      contactNumber: "",
      email: "",
    });
    setPartnerFieldsError({
      partnerIdError: "",
      partnerNameError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      cityError: "",
      pinCodeError: "",
      dateError: "",
      firstNameError: "",
      LastNameError: "",
      designationError: "",
      contactNumberError: "",
      emailError: "",
      showImageError: "",
    });
  };

  const handleShowImage = (showImage) => {
    // Set showImage to an empty string if showImage is falsy
    setPartnerFields({
      ...partnerFields,
      showImage: showImage.fileUrl || "", // This will set to showImage if it's truthy, else ""
    });

    // Reset any error related to showImage
    setPartnerFieldsError({ ...partnerFieldsError, showImageError: "" });
  };

  const handleEdit = async (rowIndex) => {
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    localStorage.setItem("screenMode", "edit");
    localStorage.setItem("selectedRowIndex", rowIndex); // store index
    var partnerDate = bindPartnerMasterDatas[rowIndex].PartnerDate;
    const partnerDatePart = partnerDate.split("T")[0];
    setPartnerFields({
      ...partnerFields,
      partnerId: bindPartnerMasterDatas[rowIndex].PartnerId,
      partnerName: bindPartnerMasterDatas[rowIndex].PartnerName,
      address: bindPartnerMasterDatas[rowIndex].PartnerAddress,
      country: bindPartnerMasterDatas[rowIndex].MstCountryId,
      state: bindPartnerMasterDatas[rowIndex].State,
      city: bindPartnerMasterDatas[rowIndex].Location,
      type: bindPartnerMasterDatas[rowIndex].Type,
      pinCode: bindPartnerMasterDatas[rowIndex].PartnerPincode,
      date: partnerDatePart,
      showImage: bindPartnerMasterDatas[rowIndex].PartnerLogo,
      firstName: bindPartnerMasterDatas[rowIndex].PartnerContactPersonFName,
      LastName: bindPartnerMasterDatas[rowIndex].PartnerContactPersonLName,
      designation:
        bindPartnerMasterDatas[rowIndex].PartnerContactPersonDesignation,
      contactNumber: bindPartnerMasterDatas[rowIndex].PartnerMobileNumber,
      email: bindPartnerMasterDatas[rowIndex].PartnerEmailId,
    });

    setMstPartnerId(bindPartnerMasterDatas[rowIndex].MstPartnerId);
  };

  const handlePartner = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setUploadDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setUploadDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setUploadDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUploadDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    } else if (flag === 6) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUploadDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    }
    setPartnerFields({
      ...partnerFields,
      type: bindPartnerMasterDatas[rowIndex].Type,
    });
    const imageData = bindImageDatas.filter(
      (ST) => ST.PartnerId == bindPartnerMasterDatas[rowIndex].MstPartnerId
    );
    setPopupImage(imageData);
    console.log("imageData", imageData);
    setPartnerData(bindPartnerMasterDatas[rowIndex]);
    const CountryrowData = bindPartnerMasterDatas[rowIndex];
    const CountryInfo = countryBindDD.find(
      (ST) => ST.value == CountryrowData.MstCountryId
    );
    const resultCountry = {
      value: CountryrowData.MstCountryId,
      label: CountryInfo ? CountryInfo.label : "",
    };

    var partnerDate = bindPartnerMasterDatas[rowIndex].PartnerDate;
    const partnerDatePart = partnerDate.split("T")[0];

    const Partnerdata2 = [resultCountry, partnerDatePart];
    setPopupFlag(flag);
    setPartnerdata2(Partnerdata2);
  };

  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [designationBindDD, setDesignationBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([]);
  const createdBy = sessionStorage.getItem("createdBy");
  const handleClick = () => {
    childRef.current.childFunction(); // Calling child function
  };
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    const trimmedPin = partnerFields.pinCode?.trim() || "";

    const containsAlphabet = /[a-zA-Z]/.test(trimmedPin);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...partnerFieldsError,
        partnerNameError:
          partnerFields.partnerName && partnerFields.partnerName.length > 0
              ? ""
            : "Enter Company Name",
        dateError:
          partnerFields.date && !isNaN(new Date(partnerFields.date).getTime())
            ? ""
            : "Select Date",
        addressError:
          partnerFields.address && partnerFields.address.length > 0
              ? ""
            : "Enter full address",
        countryError: partnerFields.country ? "" : "Select Country",
        // stateError:
        //   partnerFields.state && partnerFields.state.length > 0
        //       ? ""
        //     : "Enter State",
        // cityError:
        //   partnerFields.city && partnerFields.city.length > 0
        //       ? ""
        //     : "Enter City",
        // pinCodeError: !partnerFields.pinCode?.trim()
        //   ? "Enter Pin Code"
        //   : /[a-zA-Z]/.test(partnerFields.pinCode.trim())
        //   ? "Alphabets are not allowed"
        // //   : "",
        // pinCodeError: containsAlphabet ? "Alphabets are not allowed" : "",
        firstNameError:
          partnerFields.firstName && partnerFields.firstName.length > 0
              ? ""
            : "Enter First Name",
        LastNameError:
          partnerFields.LastName && partnerFields.LastName.length > 0
              ? ""
            : "Enter Last Name",

        contactNumberError:
          partnerFields.contactNumber && partnerFields.contactNumber.length > 0
              ? ""
            : "Enter Contact Number",
        emailError:
          partnerFields.email.length > 0
              ? !updateScreenTitle &&
                bindContactNoAndEmailDatas.find(
                  (x) =>
                    x.PartnerEmailId.toLowerCase() ===
                    partnerFields.email.toLowerCase()
                )
                ? "Email Address already available"
                : ""
            : "Enter Email",

        designationError:
          partnerFields.designation &&
          partnerFields.designation.length > 0
              ? ""
            : "Enter Designation",
      };
      setPartnerFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const partnerPayload = [
          {
            mstPartnerId: mstPartnerId ? mstPartnerId : 0,
            partnerName: partnerFields.partnerName,
            partnerId: partnerFields.partnerId,
            mstCountryId: parseInt(partnerFields.country) || 0,
            state: partnerFields.state ? partnerFields.state : null,
            location: partnerFields.city ? partnerFields.city : null,
            partnerAddress: partnerFields.address,
            partnerPincode: parseInt(partnerFields.pinCode) || null,
            partnerLogo: partnerFields.showImage,
            partnerContactPersonFName: partnerFields.firstName,
            partnerContactPersonLName: partnerFields.LastName,
            partnerContactPersonDesignation: partnerFields.designation,
            partnerMobileNumber: partnerFields.contactNumber,
            partnerEmailId: partnerFields.email,
            encryptedPwd: "ethosflo",
            type: partnerFields.type,
            partnerDate: partnerFields.date,
            bulkUpload: "",
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(partnerPayload, "PartnerAPI/IUDPartner");

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Company Added Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setPartnerFields({
              ...partnerFields,
              partnerId: response.data.Table1[0].PartnerId,
            });
            setTimeout(cancel, 10000);
          } else {
            toast.error("Failed To Add Company Data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Company Updated Successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed To Update Company Data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      setIsLoading(true);
      const data = {
        mstPartnerId: bindPartnerMasterDatas[items].MstPartnerId,
        createdBy: createdBy,
        type: partnerFields.type,
        flag: flag,
      };
      const response = await IUDAPI([data], "PartnerAPI/IUDPartner");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            `${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data Deleted Successfully 🗑️`,
            5000,
            cancel()
          );
        } else {
          toast.error(
            `Failed To Delete ${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data 👎`,
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            `${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data Active Successfully 🚫`,
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error(
            `Failed To Active ${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data 👎`,
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            `${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data Inactive Successfully ✅`,
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error(
            `Failed To Inactive ${
              partnerFields.type === "C" ? "Company" : "Partner"
            } Data 👎`,
            {
              duration: 2000,
              position: "top-center",
            }
          );
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname === "/partnermaster") {
      const screenMode = localStorage.getItem("screenMode");

      if (screenMode === "add") {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
      } else if (screenMode === "edit") {
        const storedIndex = localStorage.getItem("selectedRowIndex");
        if (storedIndex !== null && bindPartnerMasterDatas.length > 0) {
          handleEdit(Number(storedIndex));
        }
      }
    }
  }, [location, bindPartnerMasterDatas]);

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading && (
        <GridPage
          title="Partner / Company"
          header={partnerMasterHeader}
          records={bindPartnerMasterDatas}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handlePartner}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Company"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.labelBold}>Company Details</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class={mainTable.grid3}>
                    <InputText
                      inputType={"text"}
                      title={"Company Id"}
                      name={"partnerId"}
                      maxLength={20}
                      classStar={"text-red-500"}
                      content={partnerFields.partnerId}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          partnerId: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      inputType={"text"}
                      title={"Company Name"}
                      name={"partnername"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={partnerFields.partnerName}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          partnerName: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          partnerNameError:
                            partnerFields.partnerName &&
                            partnerFields.partnerName.length > 0
                              ? ""
                              : "Enter Company Name",
                        }));
                      }}
                      errorMessage={partnerFieldsError.partnerNameError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Full Address"}
                      maxLength={500}
                      name={"address"}
                      classStar={"text-red-500"}
                      content={partnerFields.address}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          address: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          addressError:
                            partnerFields.address &&
                            partnerFields.address.length > 0
                              ? ""
                              : "Enter full address",
                        }));
                      }}
                      errorMessage={partnerFieldsError.addressError}
                    />

                    <AutoDropDown
                      title="Country"
                      options={countryBindDD}
                      placeholder="Select"
                      name="country"
                      selectedOption={countryBindDD.find(
                        (x) => x.value == partnerFields.country
                      )}
                      Class="custom-class"
                      tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handlePartnerFieldsChange(value.value, e.name);
                      }}
                      controlFuncBlur={() => {
                        setPartnerFieldsError(() => ({
                          ...partnerFieldsError,
                          countryError: partnerFields.country
                            ? ""
                            : "Select Country",
                        }));
                      }}
                      errorMessage={partnerFieldsError.countryError}
                    />

                    <InputText
                      inputType="text"
                      // classStar={"text-red-500"}
                      title="State"
                      name="state"
                      maxLength={100}
                      content={partnerFields.state}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          state: e.target.value,
                        })
                      }
                      // controlFuncBlur={(e) => {
                      //    setPartnerFieldsError((partnerFieldsError) => ({
                      //     ...partnerFieldsError,
                      //     stateError:
                      //       partnerFields.state &&
                      //       partnerFields.state.length > 0
                      //         ? ""
                      //         : "Enter State",
                      //   }));
                      // }}
                      // errorMessage={partnerFieldsError.stateError}
                    />

                    <InputText
                      inputType="text"
                      // classStar={"text-red-500"}
                      title="City"
                      name="city"
                      maxLength={100}
                      content={partnerFields.city}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          city: e.target.value,
                        })
                      }
                      // controlFuncBlur={(e) => {
                      //   const value = partnerFields.city?.trim() || "";

                      //   // If value is empty, don't validate or show error
                      //   if (value === "") {
                      //     setPartnerFieldsError((partnerFieldsError) => ({
                      //       ...partnerFieldsError,
                      //       cityError: "",
                      //     }));
                      //     return;
                      //   }

                      //   // Validate only alphabets and spaces
                      //   const isValid = /^[A-Za-z ]+$/.test(value);

                      //   setPartnerFieldsError((partnerFieldsError) => ({
                      //     ...partnerFieldsError,
                      //     cityError: isValid
                      //       ? ""
                      //       : "Only alphabets and spaces allowed",
                      //   }));
                      // }}
                      // errorMessage={partnerFieldsError.cityError}
                    />

                    <InputText
                      inputType={"text"}
                      title={"Pin Code"}
                      name={"pinCode"}
                      // classStar={"text-red-500"}
                      maxLength={15}
                      content={partnerFields.pinCode}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          pinCode: e.target.value,
                        })
                      }
                      // controlFuncBlur={() => {
                      //   const trimmedPin = partnerFields.pinCode?.trim() || "";

                      //   const containsAlphabet = /[a-zA-Z]/.test(trimmedPin);

                      //   setPartnerFieldsError((prev) => ({
                      //     ...prev,
                      //     pinCodeError: containsAlphabet
                      //       ? "Alphabets are not allowed"
                      //       : "",
                      //   }));
                      // }}
                      // errorMessage={partnerFieldsError.pinCodeError}
                    />

                    <InputText
                      inputType="date"
                      title="Date"
                      classStar="text-red-500"
                      name="date"
                      content={partnerFields.date}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          date: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          dateError:
                            partnerFields.date &&
                            !isNaN(new Date(partnerFields.date).getTime())
                              ? ""
                              : "Select Date",
                        }));
                      }}
                      errorMessage={partnerFieldsError.dateError}
                    />
                  </div>
                  <FileUpload
                    title="Logo"
                    apiCall="PartnerAPI/PartnerImageUpload"
                    modalName="PartnerLogo"
                    name="showImage"
                    disabledBtn={updateScreenTitle}
                    showImage={partnerFields.showImage}
                    showImageData={handleShowImage}
                    imageUploadedError={partnerFieldsError.showImageError}
                    limitMassage={
                      "Image size limit: 2 MB. Accepted Image types:jpg, png, jpeg. Please Upload The Image After Choosing It."
                    }
                    imageShow={false}
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  />
                  <div class={mainTable.labelBold}>Contact Info</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class={mainTable.grid3}>
                    <InputText
                      inputType={"text"}
                      title={"First Name"}
                      name={"firstName"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={partnerFields.firstName}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          firstName: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          firstNameError:
                            partnerFields.firstName &&
                            partnerFields.firstName.length > 0
                                ? ""
                              : "Enter First Name",
                        }));
                      }}
                      errorMessage={partnerFieldsError.firstNameError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Last Name"}
                      name={"lastName"}
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={partnerFields.LastName}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          LastName: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {

                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          LastNameError:
                            partnerFields.LastName &&
                            partnerFields.LastName.length > 0
                                ? ""
                              : "Enter Last Name",
                        }));
                      }}
                      errorMessage={partnerFieldsError.LastNameError}
                    />
                    <InputText
                      inputType="text"
                      classStar={"text-red-500"}
                      title="Designation"
                      name="designation"
                      maxLength={50}
                      content={partnerFields.designation}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          designation: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          designationError:
                           partnerFields.designation &&
                            partnerFields.designation.length > 0
                                ? ""
                              : "Enter Designation",
                        }));
                      }}
                      errorMessage={partnerFieldsError.designationError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Contact Number"}
                      name={"contactNumber"}
                      classStar={"text-red-500"}
                      maxLength={15}
                      content={partnerFields.contactNumber}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          contactNumber: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setPartnerFieldsError((partnerFieldsError) => ({
                          ...partnerFieldsError,
                          contactNumberError:
                            partnerFields.contactNumber &&
                            partnerFields.contactNumber.length > 0
                                ? ""
                              : "Enter Contact Number",
                        }));
                      }}
                      errorMessage={partnerFieldsError.contactNumberError}
                    />
                    <InputText
                      inputType={"text"}
                      title={"Email"}
                      classStar={"text-red-500"}
                      name={"email"}
                      content={partnerFields.email}
                      maxLength={150}
                      controlFunc={(e) =>
                        setPartnerFields({
                          ...partnerFields,
                          email: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setPartnerFieldsError((partnerFieldsError) => {
                          let emailError = "";

                          if (
                            !partnerFields.email ||
                            partnerFields.email.length === 0
                          ) {
                            emailError = "Enter Email";
                          } else if (
                            !updateScreenTitle &&
                            bindContactNoAndEmailDatas.find(
                              (x) =>
                                x.PartnerEmailId.toLowerCase() ===
                                partnerFields.email.toLowerCase()
                            )
                          ) {
                            emailError = "Email address already available";
                          }

                          return {
                            ...partnerFieldsError,
                            emailError,
                          };
                        });
                      }}
                      errorMessage={partnerFieldsError.emailError}
                    />
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      Company Id :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {partnerFields.partnerId}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title={`${partnerFields.type == "C" ? "Company" : "Partner"}`}
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            uploadDetails={uploadDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
            clearData={cancel}
          />

          <PartnerPopup
            data={partnerData}
            data1={partnerdata2}
            isLoading={isLoading}
            flag={popupFlag}
            ref={childRef}
            popupImage={popupImage}
            setpopUpOpen={setpopUpOpen}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          uploadDetails={uploadDetails}
          handleSubmit={handleSubmit}
          handleUpload={handleClick}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default PartnerMaster;
